module.exports = __webpack_public_path__ + "static/img/image_j_peach.1a3c513.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_j_peach.jpg
// module id = R5++
// module chunks = 1